import SelectMaps from './src/main';

/* istanbul ignore next */
SelectMaps.install = function(Vue) {
  Vue.component(SelectMaps.name, SelectMaps);
};

export default SelectMaps;
